import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const getCourseColumns = (isForAssignment) => {
  if (isForAssignment) {
    const cols = [
      {
        id: 'imageurl',
        disablePadding: true,
        label: 'Image',
      },
      {
        id: 'name',
        disablePadding: true,
        label: 'Course Name',
      },
    ];
    return isForAssignment
      ? [{ id: 'checkbox', disablePadding: true, label: '' }, ...cols]
      : [...cols, { id: 'Action', disablePadding: true, label: 'Action' }];
  } else {
    const cols = [
      {
        id: 'courseSelect',
        label: 'Select',
      },
      {
        id: 'imageurl',
        disablePadding: true,
        label: 'Image',
      },
      {
        id: 'name',
        disablePadding: true,
        label: 'Course Name',
      },
    ];
    return isForAssignment
      ? [{ id: 'checkbox', disablePadding: true, label: '' }, ...cols]
      : [...cols, { id: 'Action', disablePadding: true, label: 'Action' }];
  }
};

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const CourseTableColumns = ({ order, orderBy, onRequestSort, isForAssignment }) => (
  <Fragment>
    <TableRow>
      {getCourseColumns(isForAssignment).map((row) => (
        <TableCell
          className="material-table__cell material-table__cell--sort material-table__cell-center"
          key={row.id}
          align={'center'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            <b>{row.label}</b>
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </Fragment>
);

CourseTableColumns.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(CourseTableColumns);
